import { render } from "./RoundedCard.vue?vue&type=template&id=51b58c4b&scoped=true"
import script from "./RoundedCard.vue?vue&type=script&lang=js"
export * from "./RoundedCard.vue?vue&type=script&lang=js"

import "./RoundedCard.vue?vue&type=style&index=0&id=51b58c4b&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b58c4b"]])

export default __exports__